<template>
  <div class="manual-page">
    <!-- 左侧导航栏 -->
    <div class="manual-sidebar">
      <div class="sidebar-content">
        <h3 class="sidebar-title">目录</h3>
        <ul class="nav-list">
          <li class="nav-item">
            <a href="#section-1" @click="scrollToSection('section-1')" class="nav-link">
              一、产品介绍
            </a>
            <ul class="nav-sub-list">
              <li class="nav-sub-item">
                <a href="#section-1-1" @click="scrollToSection('section-1-1')" class="nav-link">
                  1.1 产品简介
                </a>
              </li>
              <li class="nav-sub-item">
                <a href="#section-1-2" @click="scrollToSection('section-1-2')" class="nav-link">
                  1.2 核心功能
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <a href="#section-2" @click="scrollToSection('section-2')" class="nav-link">
              二、使用说明
            </a>
            <ul class="nav-sub-list">
              <li class="nav-sub-item">
                <a href="#section-2-1" @click="scrollToSection('section-2-1')" class="nav-link">
                  2.1 登录注册
                </a>
              </li>
              <li class="nav-sub-item">
                <a href="#section-2-2" @click="scrollToSection('section-2-2')" class="nav-link">
                  2.2 授权码激活
                </a>
              </li>
              <li class="nav-sub-item">
                <a href="#section-2-3" @click="scrollToSection('section-2-3')" class="nav-link">
                  2.3 碳芯主页面
                </a>
              </li>
              <li class="nav-sub-item">
                <a href="#section-2-4" @click="scrollToSection('section-2-4')" class="nav-link">
                  2.4 AI助手
                </a>
              </li>
              <li class="nav-sub-item">
                <a href="#section-2-5" @click="scrollToSection('section-2-5')" class="nav-link">
                  2.5 碳盘查Agent
                </a>
              </li>
              <li class="nav-sub-item">
                <a href="#section-2-6" @click="scrollToSection('section-2-6')" class="nav-link">
                  2.6 碳足迹Agent
                </a>
              </li>
              <li class="nav-sub-item">
                <a href="#section-2-7" @click="scrollToSection('section-2-7')" class="nav-link">
                  2.7 订单管理
                </a>
              </li>
              <li class="nav-sub-item">
                <a href="#section-2-8" @click="scrollToSection('section-2-8')" class="nav-link">
                  2.8 服务管理
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <div class="manual-container">
      <h1 class="manual-title">中碳Agent产品操作手册</h1>

      <div class="manual-content">
        <section id="section-1">
          <h2>一、产品介绍</h2>

          <h3 id="section-1-1">1.1 产品简介</h3>
          <p>
            中碳普惠云“碳行”系列是面向双碳领域的专业化AI Agent应用工具，包含<strong>碳盘查Agent</strong>、<strong>碳足迹Agent</strong>、<strong>ESG Agent</strong>、<strong>碳交易Agent</strong>等产品。在传统涉碳业务流程基础上融入垂类专业大模型能力以及数字化、自动化、AI化技术手段来全面提升业务效率和业务质量。
          </p>

          <h3 id="section-1-2">1.2 核心功能</h3>
          <p>
            “碳芯”AI助手专注于提供碳中和领域的咨询服务，它能够以语言交互形式针对用户关于碳中和的任何疑问提供专业的解答和建议。无论是碳中和基本概念、还是政策、标准等进阶内容，甚至是具体的技术方案，“碳芯”都能提供详尽的信息和支持。
          </p>
          <p>
            中碳碳盘查Agent提供组织层面的碳排放核算服务。能够以全流程自动化的方式帮助企业智能识别排放源、多渠道收集包含范围1/2/3的活动数据，实现精准高效的排放量计算及个性化报告生成。通过碳盘查Agent，企业能够以极低的人工及时间成本核算碳排放情况，满足自身披露、监管合规等需求。
          </p>
          <p>
            中碳碳足迹Agent提供产品层面的碳足迹核算服务。能够根据不同标准精准建立产品生命周期模型，识别排放源，自动收集数据并完成碳足迹核算。碳足迹Agent的服务帮助企业识别产品减排潜力，优化产品设计和生产过程，满足企业产品出口及供应链需求。
          </p>
          <p>
            ESG Agent与碳交易Agent也将陆续推出，共同构成中碳的碳管理解决方案，旨在帮助企业和个人更好地理解和应对涉碳需求，推动实现可持续发展及碳中和目标。
          </p>
        </section>

        <section id="section-2">
          <h2>二、使用说明</h2>

          <h3 id="section-2-1">2.1 登录注册</h3>
          <p>
            当您准备体验中碳普惠云AI服务时，打开浏览器（推荐使用谷歌、Edge、火狐等）输入网址可以直接访问：中碳普惠云AI服务
            (<a
              href="https://ai.carbonneutrality-group.com/chat-app/"
              target="_blank"
              >https://ai.carbonneutrality-group.com/chat-app/</a
            >)
          </p>
          <p>
            若您是首次登陆，可直接在首页输入框中输入您的问题，无需注册登录，便可直接和碳芯AI助手进行对话，解答您在双碳领域相关的问题。
          </p>
          <img src="@/assets/images/manual/2.1.png" />
          <p style="width: 100%; text-align: center">图2.1 首页</p>
          <p>
            若您想直接进行碳盘查或碳足迹项目，则需要注册账户，登陆使用。点击首页的碳盘查或碳足迹Agent入口，即可进入登录注册弹窗。其中，登录页面如图2.2所示，您只需要输入邮箱或手机号，并且输入密码，点击登录按钮，系统将自动验证账号信息的准确性。验证通过后，您将收到登录成功的提示，并随即被引导进入Agent的主操作页面，从而开始您的碳中和之旅。
          </p>
          <img src="@/assets/images/manual/2.2.png" />
          <p style="width: 100%; text-align: center">图2.2 登录页面</p>
          <p>
            如果您忘记密码，只需点击登录页面上的“忘记密码”按钮，即可开始密码重置流程。在这一过程中，您可以选择通过手机短信或邮箱接收验证码来验证其身份。安全验证页面如图2.3所示，系统会发送验证码到您的手机或者邮箱，您需要输入收到的验证码以完成身份验证。
          </p>
          <img src="@/assets/images/manual/2.3.png" />
          <p style="width: 100%; text-align: center">图2.3 安全验证页面</p>
          <p>
            验证成功后，重置密码页面显示如图2.4所示，输入新密码，进行更换旧密码。后续即可通过新密码进行登录。
          </p>
          <img src="@/assets/images/manual/2.4.png" />
          <p style="width: 100%; text-align: center">图2.4 重置密码页面</p>
          <P>
            注册页面如图2.5所示，您需要按照提示填写完整的表单信息，最后勾选同意《用户隐私协议》，点击“注册”按钮完成注册流程。
          </P>
          <img src="@/assets/images/manual/2.5.png" />
          <p style="width: 100%; text-align: center">图2.5 注册页面</p>

          <h3 id="section-2-2">2.2 授权码激活</h3>
          <p>
            登陆后，若您已经在外部云平台市场购买了中碳Agent服务，您可以在系统内校验您云平台订单中的授权码，激活对应服务。在如下图2.6所示，左边栏点击“授权码激活”，进行授权码的查询与激活绑定。
          </p>
          <img src="@/assets/images/manual/2.6.png" />
          <p style="width: 100%; text-align: center">图2.6 授权码激活页面</p>
          <p>图中激活码列表为用户已购买并激活绑定的授权码列表，点击“激活授权码”按钮可进行授权码的查询与激活绑定。</p>
          <img src="@/assets/images/manual/2.7.png" />
          <p style="width: 100%; text-align: center">图2.7 授权码激活弹窗</p>
          <p>输入授权码，点击“查询”按钮，此时系统会验证授权码有效性，若有效则会显示授权信息详情，包括产品名称、套餐规格、销售渠道等，用户确认无误后点击“激活”按钮，系统会执行激活操作。激活成功后，自动更新用户账户下服务信息，显示成功提示并关闭对话框；若激活失败，则显示错误提示，用户可重新输入或取消操作。</p>
          <img src="@/assets/images/manual/2.8.png" />
          <p style="width: 100%; text-align: center">图2.8 授权码查询页面</p>

          <h3 id="section-2-3">2.3 碳芯主页面</h3>
          <p>
            碳芯主页面如图2.9所示，左侧导航栏中包含三大核心区域，“AI助手区域”、“Agent 项目区域”和个人中心。AI助手区域包含“新对话”创建按钮和历史聊天记录，“Agent 项目区域”包含“新项目” 创建按钮和历史项目列表。右侧为对话区，包括“携手开展零碳之旅”的聊天输入框以及系统备案信息。用户可直接在输入框输入内容，开启AI对话。
          </p>
          <img src="@/assets/images/manual/2.9.png" />
          <p style="width: 100%; text-align: center">图2.9 碳芯主页面</p>
          <p>
            个人中心包含下级6个操作：“账户信息”、“授权码激活”、“我的订单”、“我的服务”、“帮助中心”及“退出登陆”按钮。
          </p>
          <img src="@/assets/images/manual/2.10.png" />
          <p style="width: 100%; text-align: center">图2.10 个人中心二级菜单</p>
          <p>
            选择“我的账号”，弹出账号信息页面，如图2.11所示。该页面会显示您的基本信息，包括用户名、用户ID、手机号、邮箱及所属公司。页面提供了修改手机号、邮箱和密码选项以及“用户协议及隐私说明”链接。
          </p>
          <img src="@/assets/images/manual/2.11.png" />
          <p style="width: 100%; text-align: center">图2.11 账户信息页面</p>

          <h3 id="section-2-4">2.4 AI助手</h3>
          <p>
            AI助手功能无需登录即可使用，图2.12中展示的即为AI助手对话页面。该页面设计简洁，背景为浅绿色，页面中央是AI助手的对话框，助手自我介绍为“碳芯”，并表示可以回答关于碳中和的任何问题。对话框下方设有输入框，提示用户“携手开启零碳之旅”，并提供了绿色的“提交”按钮，可用于对话的内容的发送。
          </p>
          <img src="@/assets/images/manual/2.12.png" />
          <p style="width: 100%; text-align: center">图2.12 AI助手页面</p>
          <p>
            AI对话页面如图2.13所示，在对话框中输入想要咨询的问题。例如，若您输入了“碳中和是什么”，输入完毕后，通过点击发送按钮或按回车键将问题发送给AI助手。AI助手接收到问题后，会分析并生成回答。在图中，AI助手回答了关于碳中和的定义和实现方式。如果用户需要更多信息或有其他相关问题，可以继续在对话框中输入并发送，与AI助手进行更深入的交流。同时，在AI回复过程中，您可以手动选择结束对话。
          </p>
          <img src="@/assets/images/manual/2.13.png" />
          <p style="width: 100%; text-align: center">图2.13 AI对话页面</p>
          <p>
            如图2.14所示，系统支持查看历史对话功能，您可以展开左侧导航栏查看“AI助手”的历史聊天对话，和“碳盘查或碳足迹Agent”项目对话历史，从而查看和管理对应模块的对话记录，您可以对历史对话进删除或重命名。
          </p>
          <img src="@/assets/images/manual/2.14.png" />
          <p style="width: 100%; text-align: center">图2.14 历史对话列表</p>
          <p>
            如图2.15所示，您在AI助手对话页面再选择点击“历史对话”图标，这将打开一个包含先前AI对话记录的列表。在历史对话列表中，您可以看到与AI助手的对话历史，包括日期和对话的简要内容。您还可以点击特定的对话记录来查看更详细的内容，每条对话记录旁边还提供重命名或删除的选项，允许您对历史对话进行管理。这种历史对话功能为用户提供了方便，使您能够回顾之前的交流，查找信息并继续之前的讨论。
          </p>
          <img src="@/assets/images/manual/2.15.png" />
          <p style="width: 100%; text-align: center">图2.15 历史记录操作页面</p>

          <h3 id="section-2-5">2.5 碳盘查Agent</h3>
          <p>
            碳盘查对话页面如图2.16所示，碳盘查页面是中碳普惠云AI服务中用于帮助用户进行企业碳排放盘查的工具。页面中通过一个对话框向您介绍企业碳盘查的主要流程，包括确认企业信息、盘查边界、收集活动数据、计算与报告排放量等步骤。您可以通过输入框互动，获取更多关于碳盘查的信息和指导。
          </p>
          <img src="@/assets/images/manual/2.16.png" />
          <p style="width: 100%; text-align: center">图2.16 碳盘查对话页面</p>
          <p>
            碳盘查侧边栏如图2.17所示，侧边栏是一个垂直导航工具，用于指导您完成碳盘查的五个主要步骤。这个侧边栏中可直观查看各阶段模型处理结果，在对话过程中动态更新，帮助您快速把握整个碳盘查流程。
          </p>
          <img src="@/assets/images/manual/2.17.png" />
          <p style="width: 100%; text-align: center">图2.17 碳盘查侧边栏页面</p>

          <h3 id="section-2-6">2.6 碳足迹Agent</h3>
          <p>
            碳足迹对话页面如图2.18所示，系统首先向您问好，并介绍了碳足迹Agent的功能，即帮助您进行产品碳足迹量化。碳足迹侧边栏则显示了碳足迹量化流程的各个步骤，包括边界与范围设定、生命周期清单分析、碳足迹计算和碳足迹报告生成。
          </p>
          <img src="@/assets/images/manual/2.18.png" />
          <p style="width: 100%; text-align: center">图2.18 碳足迹对话页面</p>

          <h3 id="section-2-7">2.7 订单管理</h3>
          <p>
            在个人操作栏选择“我的订单”，如图2.19所示，展示了当前用户的订单的详细信息，对于已支付的订单，您可以选择下载合同和申请开票。
          </p>
          <img src="@/assets/images/manual/2.19.png" />
          <p style="width: 100%; text-align: center">图2.19 我的订单页面</p>

          <h3 id="section-2-8">2.8 服务管理</h3>
          <p>
            在个人操作栏选择 “我的服务”查看和管理自己服务的界面。碳盘查服务页面如图2.20所示，页面分为两个主要部分：服务列表和套餐服务介绍。服务列表展示了您当前已订阅或可用的服务，包括服务名称、套餐类型、盘查范围、业务场所数量、盘查排放源数量、套餐状态及提供用户加购的操作。页面右侧提供了两种套餐服务的详细介绍，碳盘查服务页面，您可以通过点击服务列表中的“去购买”按钮来购买正式版的服务。
          </p>
          <img src="@/assets/images/manual/2.20.png" />
          <p style="width: 100%; text-align: center">图2.20 碳盘查服务页面</p>
          <p>
            碳足迹服务页面如图2.21所示，支持服务购买和申请使用。
          </p>
          <img src="@/assets/images/manual/2.21.png" />
          <p style="width: 100%; text-align: center">图2.21 碳足迹服务页面</p>
          <p>
            定制套餐页面如图2.22所示，购买操作流程在提供的界面中被分为四个主要步骤，第一步，定制套餐，您首先需要选择购买的服务套餐。界面中显示了名为"碳盘查Agent"的服务，您需要确定盘查的范围（如"范围一和二"）、业务场所数量（如"3"）以及排放源数量（如"&lt;100"）。选择完毕后将显示基于以上选择的报价。
          </p>
          <img src="@/assets/images/manual/2.22.png" />
          <p style="width: 100%; text-align: center">图2.22 定制套餐页面</p>
          <p>
            信息输入页面如图2.23所示，在确认订单步骤中，您需要提供购买方的信息，可选择以公司或个人身份购买服务，并填写相应的信息，如公司名称、统一信用代码、手机号和地址。填写完毕后，您需要点击“确认”按钮来继续。
          </p>
          <img src="@/assets/images/manual/2.23.png" />
          <p style="width: 100%; text-align: center">图2.23 开票信息输入页面</p>
          <p>
            确认订单页面如图2.24所示，该页面您可以查看Agent软件服务合同的详细内容。可以通过界面中的合同预览功能查看合同的具体内容。如果您同意合同条款，则继续进行下一步。
          </p>
          <img src="@/assets/images/manual/2.24.png" />
          <p style="width: 100%; text-align: center">图2.24 确认订单页面</p>
          <p>
            订单支付页面如图2.25所示，此步骤中，您需要确认订单信息，包括盘查主体、盘查边界等。确认无误后，您需要选择支付方式，如对公转账或扫码支付。界面提供了收款方的详细信息，包括账户名、开户银行和账号。您需要在支付时输入对应订单号，并在支付完成后关闭支付窗口。
          </p>
          <img src="@/assets/images/manual/2.25.png" />
          <p style="width: 100%; text-align: center">图2.25 订单支付页面</p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ManualView",
  methods: {
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }
};
</script>

<style scoped>
.manual-page {
  display: flex;
  max-width: 100%;
  margin: 0 auto;
  padding: 32px;
  font-size: 18px;
  color: #404040;
  justify-content: center;
  text-align: justify;
}

/* 左侧导航栏样式 */
.manual-sidebar {
  width: 280px;
  flex-shrink: 0;
  position: sticky;
  top: 32px;
  height: fit-content;
  background: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.sidebar-content {
  width: 100%;
}

.sidebar-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid rgba(24, 161, 246, 1);
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  margin-bottom: 8px;
  font-weight: bold;
}

.nav-sub-list {
  list-style: none;
  padding: 0;
  margin: 8px 0 0 16px;
}

.nav-sub-item {
  margin-bottom: 4px;
}

.nav-link {
  display: block;
  padding: 8px 12px;
  color: #404040;
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-size: 14px;
  line-height: 1.4;
}

.nav-link:hover {
  background-color: rgba(218, 241, 255, 1);
  color: rgba(24, 161, 246, 1);
  transform: translateX(4px);
}

.nav-sub-item .nav-link {
  font-size: 13px;
  padding: 6px 12px;
}

.nav-third-item .nav-link {
  font-size: 13px;
  padding: 6px 12px;
  margin-left: 16px;
}

.nav-sub-item .nav-link:hover {
  background-color: rgba(218, 241, 255, 1);
}

img {
  max-width: 100%;
}

.manual-container {
  flex: 1;
  max-width: 1200px;
  margin: 0 auto;
}

.manual-title {
  text-align: center;
  font-size: 32px;
  margin-top: 40px;
  margin-bottom: 16px;
  color: #1a1a1a;
}

.manual-content h2 {
  margin-top: 40px;
  font-size: 24px;
  color: #1a1a1a;
}

.manual-content h3 {
  margin-top: 20px;
  font-size: 20px;
  color: #262626;
}

.manual-content h4 {
  margin-top: 12px;
  font-size: 18px;
  color: #262626;
}

.manual-content p {
  text-indent: 2em;
  margin: 10px 0;
  line-height: 1.8;
}

.manual-content a {
  color: #1890ff;
  text-decoration: none;
}

.manual-content a:hover {
  text-decoration: underline;
}

img {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

</style>
